module.exports = __webpack_public_path__ + "img/fiji.1deb6f70.svg";